import React, { useState } from 'react';

import { Document, PasswordResponses, Thumbnail } from 'react-pdf';
import { pdfjs } from 'react-pdf';

import { IconButton } from 'components/IconButton/IconButton';

import styles from './FilePreview.module.scss';

// Set up the worker with fallback to CDN
pdfjs.GlobalWorkerOptions.workerSrc =
  `${process.env.REACT_APP_WEB_URL}/assets/js/pdf.worker.min.mjs` ||
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFPreview = ({
  file,
  onLoadSuccess,
  pageNumber,
  setIsLoading,
  zoom = false,
  enableZoom = true,
  onClick = () => {},
}) => {
  const [scalePreview, setScalePreview] = useState(zoom);
  const [rotateAngle, setRotateAngle] = useState(null);
  const [error, setError] = useState(null);

  return error ? (
    <p>{error}</p>
  ) : (
    <Document
      file={file.url}
      onLoadSuccess={onLoadSuccess}
      rotate={rotateAngle}
      onPassword={() => setError('Password required')}>
      <div className="u-absolute u-top-10 u-right-10 u-z-index-10">
        <IconButton
          type="white"
          elevated={true}
          icon="rotate-cw"
          className="u-margin-right--small"
          onClick={() => setRotateAngle(((rotateAngle || 0) + 90) % 360)}
        />
        {enableZoom && (
          <IconButton
            type="white"
            elevated={true}
            icon={scalePreview ? 'zoom-out' : 'zoom-in'}
            onClick={() => setScalePreview(!scalePreview)}
          />
        )}
      </div>
      <Thumbnail
        pageNumber={pageNumber}
        scale={scalePreview ? 1 : 0.5}
        onLoadSuccess={() => setIsLoading(false)}
        className={styles.thumbnail}
        onClick={onClick}
      />
    </Document>
  );
};

export default PDFPreview;
